import { Dialog } from '@material-ui/core';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { injectIntl } from 'react-intl';
import { Button } from './Button';

function ImageCropComponentRender({
  show,
  intl,
  picture,
  confirmCrop,
  onClose,
  title = 'ACTIONS.CROP_IMAGE',
}) {
  const upImg = picture.fileUrl;
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({ unit: '%', width: 30, aspect: 1 / 1 });
  const [completedCrop, setCompletedCrop] = useState(null);

  const onLoad = useCallback(img => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [completedCrop]);

  function getCroppedImg(callback) {
    if (crop.height === 0 || crop.width === 0) {
      return null;
    }
    const canvas = previewCanvasRef.current;

    return callback(canvas.toDataURL('image/jpeg', 1.0));
  }

  return (
    <Dialog open={true} fullScreen={false}>
      <div className="p-2">
        <div className="col-12">
          <h3>{intl.formatMessage({ id: title })}</h3>
        </div>
        <div className="col-12">
          <ReactCrop
            src={upImg}
            imageStyle={{ width: 400, height: 400 }}
            onImageLoaded={onLoad}
            crop={crop}
            onChange={c => setCrop(c)}
            onComplete={c => setCompletedCrop(c)}
          />
          {show ? (
            <div className="fv-plugins-message-container mb-1">
              <div className="fv-help-block">
                {intl.formatMessage({ id: 'IMAGE.CROP.ERROR' })}
              </div>
            </div>
          ) : null}
        </div>
        <div className="col-12">
          <canvas
            className="d-none"
            ref={previewCanvasRef}
            style={{
              width: Math.round(completedCrop?.width ?? 0),
              height: Math.round(completedCrop?.height ?? 0),
            }}
          />
        </div>
        <div className="pt-2 col-12 d-flex justify-content-end">
          <Button
            onClick={() => {
              try {
                getCroppedImg(confirmCrop);
              } catch (e) {
                console.error(e);
              }
            }}
            title={intl.formatMessage({ id: 'CONFIRM' })}
          />
          <Button
            classes="w-75px cancel-bg ml-3 cancel-btn cancel-text-color px-4"
            type="button"
            onClick={onClose}
            title={intl.formatMessage({ id: 'CANCEL' })}
          />
        </div>
      </div>
    </Dialog>
  );
}

export default injectIntl(ImageCropComponentRender);
